import { render, staticRenderFns } from "./ComplaintsColumnChart.vue?vue&type=template&id=7804e9fb&"
import script from "./ComplaintsColumnChart.vue?vue&type=script&lang=js&"
export * from "./ComplaintsColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports